try {
            require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const HeadingBlock = forwardRef((_a, ref) => {
    var { align = 'start', className, description, detail, headline, headlineTag, headlineVariant = 'headline', headlineWeight = 'bold', headlineSize = 'xl', descriptionVariant = 'body', descriptionWeight, descriptionSize, detailVariant = 'detail', detailWeight, detailSize, headlineLink, headlineButton, wrapping = 'break-word', ariaId } = _a, htmlProperties = __rest(_a, ["align", "className", "description", "detail", "headline", "headlineTag", "headlineVariant", "headlineWeight", "headlineSize", "descriptionVariant", "descriptionWeight", "descriptionSize", "detailVariant", "detailWeight", "detailSize", "headlineLink", "headlineButton", "wrapping", "ariaId"]);
    const link = headlineLink
        ? {
            component: headlineLink === null || headlineLink === void 0 ? void 0 : headlineLink.component,
            props: Object.assign(Object.assign({}, headlineLink.props), { variant: 'heading-link' }),
        }
        : undefined;
    return (jsxs("div", Object.assign({ ref: ref, className: classNames('cds-heading-block', className, `cds-heading-block--align-${align}`) }, htmlProperties, { children: [detail ? (jsx(Typography, { className: "cds-heading-block__detail", content: detail, tag: "div", size: detailSize, variant: detailVariant, weight: detailWeight, wrapping: wrapping, id: ariaId && `${ariaId}__detail` })) : null, headline ? (jsx(Typography, { className: "cds-heading-block__title", content: headline, tag: headlineTag, variant: headlineVariant, weight: headlineWeight, size: headlineSize, link: link, wrapping: wrapping, id: ariaId && `${ariaId}__headline` })) : null, description ? (jsx(Typography, { className: "cds-heading-block__description", content: description, tag: "div", variant: descriptionVariant, weight: descriptionWeight, size: descriptionSize, wrapping: wrapping, id: ariaId && `${ariaId}__description` })) : null, headlineButton ? jsx(Button, Object.assign({}, headlineButton)) : null] })));
});

export { HeadingBlock };
